import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';

const BlogWrapper = styled.div`
  margin-top: 50px;
  text-align: center;

  h1 {
    font-size: 3rem;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 40px;
  }

  .blog-card {
    background-color: #ffffff;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s, box-shadow 0.3s;
    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 16px 30px rgba(0, 0, 0, 0.15);
    }

    img {
      width: 100%;
      height: 250px;
      object-fit: cover;
      transition: opacity 0.3s;
      &:hover {
        opacity: 0.9;
      }
    }

    .card-body {
      padding: 1.5rem;
    }

    .card-title {
      font-size: 1.4rem;
      text-align: left;
      font-weight: 700;
      color: #34495e;
      margin-bottom: 10px;
    }

    .card-text {
      font-size: 1rem;
      color: #7f8c8d;
      line-height: 1.5;
      text-align: justify;
    }
  }

  .row {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
  }

  NavLink {
    text-decoration: none;
  }

    .col-md-4 {
    flex: 0 0 calc(33.33% - 20px); /* Take up 1/3 of the row and account for the gap */
  }
  @media (max-width: 768px) {

    .col-md-4 {
      flex: 0 0 calc(50% - 20px); /* Take up 50% width on smaller screens */
    }
    .blog-card {
      margin-bottom: 30px;
    }

    h1 {
      font-size: 2.5rem;
    }
  }
`;

const Blog = () => {
  return (
    <BlogWrapper className="container">
      <Helmet>
        <title>PLM &amp; Teamcenter Blog | NexTech PLM Solutions</title>
        <meta name="description" content="Read NexTech PLM insights on Teamcenter administration, integrations, Active Workspace, audit logging, store and forward configuration, and PLM best practices." />
        <meta name="keywords" content="PLM blog, Teamcenter blog, PLM best practices, Teamcenter tips, Active Workspace articles, audit management, store forward" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <link rel="canonical" href="https://nextechplm.com/blog" />
        <meta property="og:site_name" content="NexTech PLM Solutions" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="PLM & Teamcenter Blog | NexTech PLM Solutions" />
        <meta property="og:description" content="Read NexTech PLM insights on Teamcenter administration, integrations, Active Workspace, audit logging, store and forward configuration, and PLM best practices." />
        <meta property="og:url" content="https://nextechplm.com/blog" />
        <meta property="og:image" content="https://nextechplm.com/logo192.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="PLM & Teamcenter Blog | NexTech PLM Solutions" />
        <meta name="twitter:description" content="Read NexTech PLM insights on Teamcenter administration, integrations, Active Workspace, audit logging, store and forward configuration, and PLM best practices." />
        <meta name="twitter:image" content="https://nextechplm.com/logo192.png" />
      </Helmet>
      <h1>Our Latest Blog Posts</h1>
      <div className="row">
        {/* Blog Cards */}
        <div className="col-md-4 col-lg-4 mb-4">
          <NavLink to="/blog/audit-management">
          <div className="blog-card">
            <img src="https://placehold.co/600x400/EEE/31343C" alt="Audit management article preview" />
            <div className="card-body">
              <h5 className="card-title">Audit Management</h5>
              <p className="card-text">
                As PLM expands its scope across the enterprise, tracking what happened to data becomes increasingly important!
              </p>
            </div>
          </div>
          </NavLink>
        </div>

        <div className="col-md-4 col-lg-4 mb-4">
          <NavLink to="/blog/Configure-Store-and-Forward">
          <div className="blog-card">
            <img src="https://placehold.co/600x400/EEE/31343C" alt="Store and forward article preview" />
            <div className="card-body">
              <h5 className="card-title">Configure Store and Forward</h5>
              <p className="card-text">
                Global company operations require sharing high volumes of business data seamlessly.
              </p>
            </div>
          </div>
          </NavLink>
        </div>

        <div className="col-md-4 col-lg-4 mb-4">
          <NavLink to="/blog/Logical-object-post">
          <div className="blog-card">
            <img src="https://placehold.co/600x400/EEE/31343C" alt="Logical objects article preview" />
            <div className="card-body">
              <h5 className="card-title">Logical Object Post</h5>
              <p className="card-text">
                Logical objects consolidate properties from related objects into a single, simplified structure.
              </p>
            </div>    
          </div>
          </NavLink>
        </div>

        {/* Blog Card 4 */}
        <div className="col-md-4 col-lg-4 mb-4">
          <div className="blog-card">
            <img src="https://placehold.co/600x400/EEE/31343C" alt="Reactive logging article preview" />
            <div className="card-body">
              <h5 className="card-title"> Reactive Logging</h5>
              <p className="card-text">
              Reactive logging in Active Workspace enables regular users to generate the log reactively in response to the issue/problem they observe while performing a specific business use case. 
              </p>
            </div>
          </div>
        </div>

        {/* Blog Card 5 */}
        <div className="col-md-4 col-lg-4 mb-4">
          <div className="blog-card">
            <img src="https://placehold.co/600x400/EEE/31343C" alt="Security propagation article preview" />
            <div className="card-body">
              <h5 className="card-title">Security propagation</h5>
              <p className="card-text">
              It‘s a very common business scenario where you need to copy property values from one object to another objects say Item to Item Revisions to datasets/forms and so on, also from item 
              </p>
            </div>
          </div>
        </div>

        {/* Blog Card 6 */}
        <div className="col-md-4 col-lg-4 mb-4">
          <div className="blog-card">
            <img src="https://placehold.co/600x400/EEE/31343C" alt="Siemens Teamcenter 11 article preview" />
            <div className="card-body">
              <h5 className="card-title"> Siemens Teamcenter 11</h5>
              <p className="card-text">
              Siemens Teamcenter 11.2 now enables us to manage and share admin data across the PLM environments efficiently  Export, Import, Synchronize, Compare and Analyze Admin Data
              </p>
            </div>
          </div>
        </div>

        {/* Blog Card 7 */}
        <div className="col-md-4 col-lg-4 mb-4">
          <div className="blog-card">
            <img src="https://placehold.co/600x400/EEE/31343C" alt="Security model testing article preview" />
            <div className="card-body">
              <h5 className="card-title"> Siemens Teamcenter now Supports Automation of your security model testing</h5>
              <p className="card-text">
              The world has become a scare place, everyday we hear about different security problems putting more and more challenges in ensuring the protection of senstive information data in PLM 
              </p>
            </div>
          </div>
        </div>
          
          {/* Blog Card 8 */}
          <div className="col-md-4 col-lg-4 mb-4">
          <div className="blog-card">
            <img src="https://placehold.co/600x400/EEE/31343C" alt="File upload download article preview" />
            <div className="card-body">
              <h5 className="card-title">  Siemens Teamcenter now Supports Upload and Download of Files Rev1</h5>
              <p className="card-text">
              It‘s a common business scenario where you need to upload / download large size files such as MS word, CAE result files and so on to/from Teamcenter. 
              </p>
            </div>
          </div>
        </div>
        
    
      </div>
    </BlogWrapper>
  );
};

export default Blog;
